let monetisationCtaBrand = window?.app_data?.appcmsMain?.brand?.monetizationCta
let primaryCtaStyle = {
    backgroundColor: monetisationCtaBrand?.primary?.backgroundColor,
    color: monetisationCtaBrand?.primary?.textColor,
    border: `${monetisationCtaBrand?.primary?.border?.width} solid ${monetisationCtaBrand?.primary?.border?.color}`
}
let primaryCtaHoverStyle = {
    backgroundColor: monetisationCtaBrand?.primaryHover?.backgroundColor,
    color: monetisationCtaBrand?.primaryHover?.textColor,
    border: `${monetisationCtaBrand?.primaryHover?.border?.width} solid ${monetisationCtaBrand?.primaryHover?.border?.color}`
}
let secondaryCtaStyle = {
    backgroundColor: monetisationCtaBrand?.secondary?.backgroundColor,
    color: monetisationCtaBrand?.secondary?.textColor,
    border: `${monetisationCtaBrand?.secondary.border?.width} solid ${monetisationCtaBrand?.secondary?.border?.color}`
}
let secondaryCtaHoverStyle = {
    backgroundColor: monetisationCtaBrand?.secondaryHover?.backgroundColor,
    color: monetisationCtaBrand?.secondaryHover?.textColor,
    border: `${monetisationCtaBrand?.secondaryHover.border?.width} solid ${monetisationCtaBrand?.secondaryHover?.border?.color}`
}
let optionCtaStyle = {
    backgroundColor: monetisationCtaBrand?.option?.backgroundColor,
    color: monetisationCtaBrand?.option?.textColor,
    border: `${monetisationCtaBrand?.option?.border?.width} solid ${monetisationCtaBrand?.option?.border?.color}`
}
let optionCtaHoverStyle = {
    backgroundColor: monetisationCtaBrand?.optionHover?.backgroundColor,
    color: monetisationCtaBrand?.optionHover?.textColor,
    border: `${monetisationCtaBrand?.optionHover?.border?.width} solid ${monetisationCtaBrand?.optionHover?.border?.color}`
}

export {primaryCtaStyle,primaryCtaHoverStyle,secondaryCtaStyle,secondaryCtaHoverStyle,optionCtaStyle,optionCtaHoverStyle}